module.exports = __webpack_public_path__ + "static/media/giftLink.b372380c.svg";